/*
 *
 *  actions
 *
 */

import {
  //LOAD_VIDEO_TEAM
  LOAD_PURCHASE_INVOICE,
  LOAD_PURCHASE_INVOICE_SUCCESS,
  LOAD_PURCHASE_INVOICE_ERROR,
  CREATE_PURCHASE_INVOICE,
  CREATE_PURCHASE_INVOICE_SUCCESS,
  CREATE_PURCHASE_INVOICE_ERROR,
  UPDATE_PURCHASE_INVOICE,
  UPDATE_PURCHASE_INVOICE_SUCCESS,
  UPDATE_PURCHASE_INVOICE_ERROR,
  LOAD_PURCHASE_PARTY_VENDOR_ADDRESS,
  LOAD_PURCHASE_PARTY_VENDOR_ADDRESS_SUCCESS,
  LOAD_PURCHASE_PARTY_VENDOR_ADDRESS_ERROR,
  CREATE_PURCHASE_PARTY_VENDOR_ADDRESS,
  CREATE_PURCHASE_PARTY_VENDOR_ADDRESS_SUCCESS,
  CREATE_PURCHASE_PARTY_VENDOR_ADDRESS_ERROR,
  DELETE_PURCHASE_INVOICE,
  DELETE_PURCHASE_INVOICE_SUCCESS,
  DELETE_PURCHASE_INVOICE_ERROR,
  LOAD_PURCHASE_INVOICE_RECORDS_META_DATA,
  LOAD_PURCHASE_INVOICE_RECORDS_META_DATA_SUCCESS,
  LOAD_PURCHASE_INVOICE_RECORDS_META_DATA_ERROR,
  LOAD_PARTIES_TRANSACTION,
  LOAD_PARTIES_TRANSACTION_SUCCESS,
  LOAD_PURCHASE_INVOICE_CATEGORY,
  LOAD_PURCHASE_INVOICE_CATEGORY_SUCCESS,
  LOAD_PURCHASE_INVOICE_CATEGORY_ERROR,
  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY,
  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_SUCCESS,
  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_ERROR,
  LOAD_PARTIES_TRANSACTION_ERROR,
  LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION,
  LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION_SUCCESS,
  LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION_ERROR,
  LOAD_PURCHASE_TOTAL,
  LOAD_PURCHASE_TOTAL_SUCCESS,
  LOAD_PURCHASE_TOTAL_ERROR,
  LOAD_TOTAL_PAID,
  LOAD_TOTAL_PAID_SUCCESS,
  LOAD_TOTAL_PAID_ERROR,
  LOAD_TOTAL_UNPAID,
  LOAD_TOTAL_UNPAID_SUCCESS,
  LOAD_TOTAL_UNPAID_ERROR,
  LOAD_PURCHASE_BARCODE,
  LOAD_PURCHASE_BARCODE_SUCCESS,
  LOAD_PURCHASE_BARCODE_ERROR,
  LOAD_PURCHASE_PRINT_RECEIPT,
  LOAD_PURCHASE_PRINT_RECEIPT_SUCCESS,
  LOAD_PURCHASE_PRINT_RECEIPT_ERROR,
  LOAD_PURCHASE_IMPORT_RAM_LIST,
  LOAD_PURCHASE_IMPORT_RAM_LIST_SUCCESS,
  LOAD_PURCHASE_IMPORT_RAM_LIST_ERROR,
  LOAD_PURCHASE_BARCODE_UPDATE_LIST,
  LOAD_PURCHASE_BARCODE_UPDATE_LIST_SUCCESS,
  LOAD_PURCHASE_BARCODE_UPDATE_LIST_ERROR,
  LOAD_SCAN_BARCODE_LIST,
  LOAD_SCAN_BARCODE_LIST_SUCCESS,
  LOAD_SCAN_BARCODE_LIST_ERROR,
} from "./constants";

// load purchase
export function loadPurchaseInvoice(salesInvoiceList) {
  return {
    type: LOAD_PURCHASE_INVOICE,
    salesInvoiceList,
  };
}

export function loadPurchaseInvoiceSuccess(purchase_invoice_list, success) {
  return {
    type: LOAD_PURCHASE_INVOICE_SUCCESS,
    purchase_invoice_list,
    success,
  };
}

export function loadPurchaseInvoiceError(error) {
  return {
    type: LOAD_PURCHASE_INVOICE_ERROR,
    error,
  };
}

// load barCode
export function loadPurchaseBarcode(salesInvoiceList) {
  return {
    type: LOAD_PURCHASE_BARCODE,
    salesInvoiceList,
  };
}

export function loadPurchaseBarcodeSuccess(purchase_barcode_list, success) {
  return {
    type: LOAD_PURCHASE_BARCODE_SUCCESS,
    purchase_barcode_list,
    success,
  };
}

export function loadPurchaseBarcodeError(error) {
  return {
    type: LOAD_PURCHASE_BARCODE_ERROR,
    error,
  };
}
// load purchase receipt
export function loadPurchasePrintReceipt(purchaseReceipt) {
  return {
    type: LOAD_PURCHASE_PRINT_RECEIPT,
    purchaseReceipt,
  };
}

export function loadPurchasePrintReceiptSuccess(
  purchase_print_receipt,
  success
) {
  return {
    type: LOAD_PURCHASE_PRINT_RECEIPT_SUCCESS,
    purchase_print_receipt,
    success,
  };
}

export function loadPurchasePrintReceiptError(error) {
  return {
    type: LOAD_PURCHASE_PRINT_RECEIPT_ERROR,
    error,
  };
}

// load purchase receipt
export function loadPurchaseImportRamList(purchaseReceipt) {
  return {
    type: LOAD_PURCHASE_IMPORT_RAM_LIST,
    purchaseReceipt,
  };
}

export function loadPurchaseImportRamListSuccess(import_ram_list, success) {
  return {
    type: LOAD_PURCHASE_IMPORT_RAM_LIST_SUCCESS,
    import_ram_list,
    success,
  };
}

export function loadPurchaseImportRamListError(error) {
  return {
    type: LOAD_PURCHASE_IMPORT_RAM_LIST_ERROR,
    error,
  };
}

// load barcode update
export function loadPurchaseBarcodeUpdateList(purchaseBarcode) {
  return {
    type: LOAD_PURCHASE_BARCODE_UPDATE_LIST,
    purchaseBarcode,
  };
}

export function loadPurchaseBarcodeUpdateListSuccess(
  barcode_update_list,
  success
) {
  return {
    type: LOAD_PURCHASE_BARCODE_UPDATE_LIST_SUCCESS,
    barcode_update_list,
    success,
  };
}

export function loadPurchaseBarcodeUpdateListError(error) {
  return {
    type: LOAD_PURCHASE_BARCODE_UPDATE_LIST_ERROR,
    error,
  };
}

// load dropdown barcode
export function loadScanBarcodeList(purchaseBarcode) {
  return {
    type: LOAD_SCAN_BARCODE_LIST,
    purchaseBarcode,
  };
}

export function loadScanBarcodeListSuccess(scan_barcode_list, success) {
  return {
    type: LOAD_SCAN_BARCODE_LIST_SUCCESS,
    scan_barcode_list,
    success,
  };
}

export function loadScanBarcodeListError(error) {
  return {
    type: LOAD_SCAN_BARCODE_LIST_ERROR,
    error,
  };
}

// load parties
export function loadDashboardTransactions(transactionsList) {
  return {
    type: LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION,
    transactionsList,
  };
}

export function loadDashboardTransactionsSuccess(
  dashboard_transactions,
  success
) {
  return {
    type: LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION_SUCCESS,
    dashboard_transactions,
    success,
  };
}

export function loadDashboardTransactionsError(error) {
  return {
    type: LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION_ERROR,
    error,
  };
}

// load total balance
export function loadPurchaseTotal(transactionsList) {
  return {
    type: LOAD_PURCHASE_TOTAL,
    transactionsList,
  };
}

export function loadPurchaseTotalSuccess(purchase_total_list, success) {
  return {
    type: LOAD_PURCHASE_TOTAL_SUCCESS,
    purchase_total_list,
    success,
  };
}

export function loadPurchaseTotalError(error) {
  return {
    type: LOAD_PURCHASE_TOTAL_ERROR,
    error,
  };
}

// load total balance
export function loadTotalPaid(transactionsList) {
  return {
    type: LOAD_TOTAL_PAID,
    transactionsList,
  };
}

export function loadTotalPaidSuccess(total_paid_list, success) {
  return {
    type: LOAD_TOTAL_PAID_SUCCESS,
    total_paid_list,
    success,
  };
}

export function loadTotalPaidError(error) {
  return {
    type: LOAD_TOTAL_PAID_ERROR,
    error,
  };
}

// load total balance
export function loadTotalUnPaid(transactionsList) {
  return {
    type: LOAD_TOTAL_UNPAID,
    transactionsList,
  };
}

export function loadTotalUnPaidSuccess(total_unpaid_list, success) {
  return {
    type: LOAD_TOTAL_UNPAID_SUCCESS,
    total_unpaid_list,
    success,
  };
}

export function loadTotalUnPaidError(error) {
  return {
    type: LOAD_TOTAL_UNPAID_ERROR,
    error,
  };
}

// load pary address
export function loadPartyVendorAddress(addressList) {
  return {
    type: LOAD_PURCHASE_PARTY_VENDOR_ADDRESS,
    addressList,
  };
}

export function loadPartyVendorAddressSuccess(party_address_list, success) {
  return {
    type: LOAD_PURCHASE_PARTY_VENDOR_ADDRESS_SUCCESS,
    party_address_list,
    success,
  };
}

export function loadPartyVendorAddressError(error) {
  return {
    type: LOAD_PURCHASE_PARTY_VENDOR_ADDRESS_ERROR,
    error,
  };
}

// Category

export function loadPartiesCategory(categoryList) {
  return {
    type: LOAD_PURCHASE_INVOICE_CATEGORY,
    categoryList,
  };
}

export function loadPartiesCategorySuccess(category_list, success) {
  return {
    type: LOAD_PURCHASE_INVOICE_CATEGORY_SUCCESS,
    category_list,
    success,
  };
}

export function loadPartiesCategoryError(error) {
  return {
    type: LOAD_PURCHASE_INVOICE_CATEGORY_ERROR,
    error,
  };
}

//category list
export function createPartiesCategoryList(categoryList) {
  return {
    type: CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY,
    categoryList,
  };
}

export function createPartiesCategoryListSuccess(categoryList, success) {
  return {
    type: CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_SUCCESS,
    categoryList,
    success,
  };
}

export function createPartiesCategoryListError(error) {
  return {
    type: CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_ERROR,
    error,
  };
}

// party address create
export function createPartyVendorAddress(partyAddress) {
  return {
    type: CREATE_PURCHASE_PARTY_VENDOR_ADDRESS,
    partyAddress,
  };
}

export function createPartyVendorAddressSuccess(partyAddress, success) {
  return {
    type: CREATE_PURCHASE_PARTY_VENDOR_ADDRESS_SUCCESS,
    partyAddress,
    success,
  };
}

export function createPartyVendorAddressError(error) {
  return {
    type: CREATE_PURCHASE_PARTY_VENDOR_ADDRESS_ERROR,
    error,
  };
}

// load parties
export function createPurchaseInvoiceList(purchaseInvoiceList) {
  return {
    type: CREATE_PURCHASE_INVOICE,
    purchaseInvoiceList,
  };
}

export function createPurchaseInvoiceListSuccess(purchaseInvoiceList, success) {
  return {
    type: CREATE_PURCHASE_INVOICE_SUCCESS,
    purchaseInvoiceList,
    success,
  };
}

export function createPurchaseInvoiceListError(error) {
  return {
    type: CREATE_PURCHASE_INVOICE_ERROR,
    error,
  };
}
// load parties
export function updatePurchaseInvoiceList(salesInvoiceList) {
  return {
    type: UPDATE_PURCHASE_INVOICE,
    salesInvoiceList,
  };
}

export function updatePurchaseInvoiceListSuccess(salesInvoiceList, success) {
  return {
    type: UPDATE_PURCHASE_INVOICE_SUCCESS,
    salesInvoiceList,
    success,
  };
}

export function updatePurchaseInvoiceListError(error) {
  return {
    type: UPDATE_PURCHASE_INVOICE_ERROR,
    error,
  };
}
// load parties
export function deletePurchaseInvoiceList(salesInvoiceList) {
  return {
    type: DELETE_PURCHASE_INVOICE,
    salesInvoiceList,
  };
}

export function deletePurchaseInvoiceListSuccess(salesInvoiceList, success) {
  return {
    type: DELETE_PURCHASE_INVOICE_SUCCESS,
    salesInvoiceList,
    success,
  };
}

export function deletePurchaseInvoiceListError(error) {
  return {
    type: DELETE_PURCHASE_INVOICE_ERROR,
    error,
  };
}

// load parties transaction
export function loadPartiesTransaction(purchaseInvoiceList) {
  return {
    type: LOAD_PARTIES_TRANSACTION,
    purchaseInvoiceList,
  };
}

export function loadPartiesTransactionSuccess(
  parties_transaction_list,
  success
) {
  return {
    type: LOAD_PARTIES_TRANSACTION_SUCCESS,
    parties_transaction_list,
    success,
  };
}

export function loadPartiesTransactionError(error) {
  return {
    type: LOAD_PARTIES_TRANSACTION_ERROR,
    error,
  };
}

export function loadPurchaseInvoiceRecordsMetaData() {
  return {
    type: LOAD_PURCHASE_INVOICE_RECORDS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadPurchaseInvoiceRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_PURCHASE_INVOICE_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadPurchaseInvoiceRecordsMetaDataError(error) {
  return {
    type: LOAD_PURCHASE_INVOICE_RECORDS_META_DATA_ERROR,
    error,
  };
}

const actions = {
  loadPurchaseInvoice,
  loadPurchaseInvoiceSuccess,
  loadPurchaseInvoiceError,

  loadPurchaseBarcode,
  loadPurchaseBarcodeSuccess,
  loadPurchaseBarcodeError,

  loadPurchasePrintReceipt,
  loadPurchasePrintReceiptSuccess,
  loadPurchasePrintReceiptError,

  loadPurchaseImportRamList,
  loadPurchaseImportRamListSuccess,
  loadPurchaseImportRamListError,

  loadPurchaseBarcodeUpdateList,
  loadPurchaseBarcodeUpdateListSuccess,
  loadPurchaseBarcodeUpdateListError,

  loadScanBarcodeList,
  loadScanBarcodeListSuccess,
  loadScanBarcodeListError,

  loadDashboardTransactions,
  loadDashboardTransactionsSuccess,
  loadDashboardTransactionsError,

  loadPurchaseTotal,
  loadPurchaseTotalSuccess,
  loadPurchaseTotalError,
  loadTotalPaid,
  loadTotalPaidSuccess,
  loadTotalPaidError,
  loadTotalUnPaid,
  loadTotalUnPaidSuccess,
  loadTotalUnPaidError,

  loadPartyVendorAddress,
  loadPartyVendorAddressSuccess,
  loadPartyVendorAddressError,

  loadPartiesCategory,
  loadPartiesCategorySuccess,
  loadPartiesCategoryError,

  createPartiesCategoryList,
  createPartiesCategoryListSuccess,
  createPartiesCategoryListError,

  loadPartiesTransaction,
  loadPartiesTransactionSuccess,
  loadPartiesTransactionError,

  createPurchaseInvoiceList,
  createPurchaseInvoiceListSuccess,
  createPurchaseInvoiceListError,

  createPartyVendorAddress,
  createPartyVendorAddressSuccess,
  createPartyVendorAddressError,

  updatePurchaseInvoiceList,
  updatePurchaseInvoiceListSuccess,
  updatePurchaseInvoiceListError,

  deletePurchaseInvoiceList,
  deletePurchaseInvoiceListSuccess,
  deletePurchaseInvoiceListError,

  loadPurchaseInvoiceRecordsMetaData,
  loadPurchaseInvoiceRecordsMetaDataSuccess,
  loadPurchaseInvoiceRecordsMetaDataError,
};

export default actions;
